
<template>
    <div class="center">
        <vs-dialog prevent-close v-model="active" @close="active = false">
            <template #header>
                <h4 class="not-margin">
                    Crear accesos masivamente
                </h4>
            </template>
            <div class="con-form" ref="content">
                <h6><strong>¿Esta seguro de dar accesos accesos masivamente?</strong></h6>
            </div>
            <template #footer>
                <div class="footer-dialog">
                        <vs-row>
                            <vs-col sm="6" lg="6">
                            <vs-button
                                danger
                                flat
                                @click="active = false">
                                Cancelar
                            </vs-button>
                            </vs-col>
                            <vs-col sm="6" lg="6">
                            <vs-button
                                success
                                class="ml-auto"
                                @click="postAccesosMasivosFamiliares()">
                                Aceptar
                            </vs-button>
                            </vs-col>
                        </vs-row>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>
<script>
import accesibilidad from '../../../../../api/requests/accesibilidad.js'
export default {
    props:[
      'value',
      'filtros'
    ],
    data:() => ({
        active: false,
    }),
    methods:{
        async postAccesosMasivosFamiliares(){
            const loading = this.$vs.loading()
            try{
                // const formData = new FormData()
                // formData.append('institucion_id', this.filtros.institucion)
                // formData.append('ciclo_escolar_id', this.filtros.cicloEscolar)
                // formData.append('status_acceso', this.filtros.estatus)
                // if(this.filtros.grupo[0] == ''){
                //     const eliminar = this.filtros.grupo.shift()
                //     formData.append('grupo_id', this.filtros.grupo)
                // }else{
                //     formData.append('grupo_id', this.filtros.grupo)
                // }
                const params = {
                    page: this.page,
                    institucion_id: this.filtros.institucion,
                    ciclo_escolar_id: this.filtros.cicloEscolar,
                    status_acceso: this.filtros.estatus
                }
                
                if(this.filtros.grupo[0] == ''){
                    const eliminar = this.filtros.grupo.shift()
                    params.grupo_id = this.filtros.grupo
                }else{
                    params.grupo_id = this.filtros.grupo
                }
                const {data: response} = await accesibilidad.postAccesosMasivosFamiliares(params)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.message
                })
                this.active = false
                this.$emit('refreshTable')
                loading.close()
            }catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    duration: 10000,
                    title: 'Se produjo un error',
                    text: 'Favor de comunicarse con el administrador'
                })
            }
        }
    },
    watch:{
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>
